<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18fWKhl/tc-custom/9781398476561.jpg?1718282806445" alt="This image is the cover for the book The Adventures of Sherlock Bones"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Adventures of Sherlock Bones
      </h1>
      <p class="bookDescription body article font2">
        <p>Stanley is happily minding his own business when Bones suddenly crashes into the room with news that his friend Berkeley Basset thinks he’s got a ghost. He didn’t have one before, so Bones instantly suspects foul play. Stanley is unimpressed and really doesn’t fancy spending the night in a potentially poltergeist-ridden castle out in the middle of nowhere. Crashes, bangs and weird noises convince Bones that a secret tunnel exists. A voice in the wall turns out to be a pup named Percy, who then joins them, and Watson on a second expedition to search for clues to Templar treasure. Percy has never heard of the Templars and asks Watson many questions. He is upset that they got dissolved but is happy when he realises that Friday 13th is only unlucky if you are a medieval knight. For this challenge, they have to use eight different modes of transport. Which will they choose? Will Stanley survive and will they win the race?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jaris Ash
      </h2>
      
      <p class="authorDescription body article">Jaris Ash has held various office-based jobs in the past, but she has always had a passion for writing and a love for dogs. Eventually, she decided to combine her two interests, writing from a dog’s perspective for her local training club newsletter, and creating a series of stories for use in Animal Assisted Therapy sessions. All of the characters in her stories are inspired by her real-life dogs, who have made the recent years extremely interesting, even though they have driven her a bit bonkers at times. With trips round Europe – all the way across to Tunnel Harry in Poland on one occasion – as well as agility Have-A-Go events at local schools, fairs and fetes, it’s safe to say that things are never dull in her household.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?46a5d431